import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {DiagramMetaInterface, Theme} from './diagram-meta.interface';

@Injectable()
export class DiagramMetaService {
  private diagramMetaSubject: BehaviorSubject<DiagramMetaInterface> = new BehaviorSubject(null);
  diagramMeta$: Observable<DiagramMetaInterface> = this.diagramMetaSubject.asObservable();

  private diagramThemesSubject: BehaviorSubject<Theme[]> = new BehaviorSubject(null);
  diagramThemes$: Observable<Theme[]> = this.diagramThemesSubject.asObservable();

  constructor() {}

  setMeta(metaData: DiagramMetaInterface): void {
    this.diagramMetaSubject.next(metaData);
  }

  getMetaSync(): DiagramMetaInterface {
    return this.diagramMetaSubject.getValue();
  }

  setThemes(themes: Theme[] = []) {
    this.diagramThemesSubject.next(themes);
  }
}
